export default __webpack_public_path__ + "static/media/logo_lg_tag.285bcdf0.svg";